(function(){'use strict';

function initStickyBuy(root){
  if(!root||root.dataset.bpbStickyBuyReady==='true')return;
  var form=root.querySelector('form.bpb-pdp__form');
  var bar=root.querySelector('[data-bpb-sticky-buy]');
  if(!form||!bar)return;

  var mainAdd=form.querySelector('[data-add-to-cart]');
  var mainAddText=form.querySelector('[data-add-to-cart-text]');
  var priceNode=form.querySelector('[data-product-price]');
  var nameToggle=form.querySelector('[data-bpb-name-toggle]');
  var logoToggle=form.querySelector('[data-bpb-logo-toggle]');
  var refillOffer=form.querySelector('[data-bpb-refill-offer]');
  var stickyPrice=bar.querySelector('[data-bpb-sticky-price]');
  var stickyMeta=bar.querySelector('[data-bpb-sticky-meta]');
  var stickyAdd=bar.querySelector('[data-bpb-sticky-add]');
  if(!mainAdd||!stickyAdd)return;

  root.dataset.bpbStickyBuyReady='true';
  var media=window.matchMedia('(max-width: 768px)');
  var frame=0;

  function normaliseInk(value){
    value=String(value||'').trim();
    if(!value)return '';
    return /ink/i.test(value)?value:(value+' Ink');
  }

  function selectedInk(){
    var fields=Array.prototype.slice.call(form.querySelectorAll('.bpb-pdp__field'));
    for(var i=0;i<fields.length;i++){
      var label=fields[i].querySelector('label');
      var select=fields[i].querySelector('select');
      var labelText=label?String(label.textContent||'').toLowerCase():'';
      if(select&&labelText.indexOf('ink')>-1)return normaliseInk(select.value);
    }
    return normaliseInk(bar.getAttribute('data-ink')||'');
  }

  function personalisationLabel(){
    var nameSelected=Boolean(nameToggle&&nameToggle.checked);
    var logoSelected=Boolean(logoToggle&&logoToggle.checked);
    if(nameSelected&&logoSelected)return 'Personalised +₹57';
    if(nameSelected)return 'Personalised +₹27';
    if(logoSelected)return 'Personalised +₹30';
    return '';
  }

  function syncContent(){
    if(stickyPrice&&priceNode)stickyPrice.textContent=String(priceNode.textContent||'').trim();
    var meta=[];
    var ink=selectedInk();
    var personalised=personalisationLabel();
    if(ink)meta.push(ink);
    if(personalised)meta.push(personalised);
    if(stickyMeta)stickyMeta.textContent=meta.length?meta.join(' · '):'Ready to add';

    bar.classList.toggle('is-personalised',Boolean(personalised));
    stickyAdd.disabled=Boolean(mainAdd.disabled);
    if(mainAddText){
      var label=String(mainAddText.textContent||'').trim();
      stickyAdd.textContent=label||'Add to Cart';
    }else{
      stickyAdd.textContent=mainAdd.disabled?'Sold Out':'Add to Cart';
    }
  }

  function topOcclusion(){
    var stickyHeader=document.querySelector('.ltn__header-sticky.sticky-active');
    if(!stickyHeader)return 0;
    var rect=stickyHeader.getBoundingClientRect();
    return Math.max(0,Math.min(window.innerHeight||0,rect.bottom||0));
  }

  function shouldShow(){
    if(!media.matches)return false;
    if(refillOffer&&!refillOffer.hidden)return false;
    var rect=mainAdd.getBoundingClientRect();
    return rect.bottom<=topOcclusion()+2;
  }

  function update(){
    frame=0;
    syncContent();
    var visible=shouldShow();
    bar.hidden=!visible;
    bar.setAttribute('aria-hidden',visible?'false':'true');
    document.documentElement.classList.toggle('bpb-sticky-buy-visible',visible);
    if(visible){
      var measured=Math.ceil(bar.getBoundingClientRect().height)||68;
      document.documentElement.style.setProperty('--bpb-sticky-buy-height',measured+'px');
    }else{
      document.documentElement.style.removeProperty('--bpb-sticky-buy-height');
    }
  }

  function schedule(){
    if(frame)return;
    frame=window.requestAnimationFrame(update);
  }

  stickyAdd.addEventListener('click',function(){
    syncContent();
    if(stickyAdd.disabled)return;
    mainAdd.click();
  });

  form.addEventListener('change',schedule);
  form.addEventListener('input',schedule);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('pageshow',schedule);
  if(window.visualViewport)window.visualViewport.addEventListener('resize',schedule,{passive:true});

  if(typeof media.addEventListener==='function')media.addEventListener('change',schedule);
  else if(typeof media.addListener==='function')media.addListener(schedule);

  var observer=new MutationObserver(schedule);
  if(priceNode)observer.observe(priceNode,{childList:true,characterData:true,subtree:true});
  if(mainAddText)observer.observe(mainAddText,{childList:true,characterData:true,subtree:true});
  observer.observe(mainAdd,{attributes:true,attributeFilter:['disabled']});
  if(refillOffer)observer.observe(refillOffer,{attributes:true,attributeFilter:['hidden']});

  update();
}

function initAll(){
  document.querySelectorAll('[data-bpb-pdp]').forEach(initStickyBuy);
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);
else initAll();

document.addEventListener('shopify:section:load',function(event){
  if(event&&event.target){
    var root=event.target.matches&&event.target.matches('[data-bpb-pdp]')?event.target:event.target.querySelector&&event.target.querySelector('[data-bpb-pdp]');
    if(root)initStickyBuy(root);
  }
});
})();